import { DirectoryCreateRecordParam } from 'api/requests';
import { DirectorySchemaData } from 'api/types/data/directory/directory';
import { parseDirectoryRecordFieldParam } from 'modules/directory/common/helpers';

export const getCreateSubmitData = (
  currentSchema: DirectorySchemaData,
  values: {}
): DirectoryCreateRecordParam => ({
  schemaId: currentSchema.id,
  fields: parseDirectoryRecordFieldParam(currentSchema, values),
});
